import { Vnc } from "@/admin/vm/Vnc.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main_custom/admin/console/$location/$vmId")({
    component: Component,
});

function Component() {
    const { vmId, location } = Route.useParams();
    return <Vnc vmId={vmId} location={location} />;
}
